import React, { useState } from 'react';
import { Box, CircularProgress, Alert } from '@mui/material';
import Header from './Header';
import Navigation from './Navigation';
import MainContent from './MainContent';
import { useData } from '../context/DataContext';

// アプリケーションコンテンツコンポーネント
function AppContent({ onLanguageChange }) {
  // データコンテキストから状態を取得
  const { 
    conversations, 
    themes, 
    tags, 
    favorites, 
    isLoading, 
    error, 
    toggleFavorite 
  } = useData();

  // 現在選択されているビュー（時系列 or テーマ別）
  const [currentView, setCurrentView] = useState('timeline');
  
  // 現在選択されている会話
  const [selectedConversation, setSelectedConversation] = useState(null);
  
  // 検索クエリ
  const [searchQuery, setSearchQuery] = useState('');
  
  // フィルター設定
  const [filters, setFilters] = useState({
    dateRange: null,
    tags: [],
    themes: [],
  });

  // ナビゲーション項目がクリックされたときの処理
  const handleNavItemClick = (view) => {
    setCurrentView(view);
    setSelectedConversation(null);
  };

  // 会話がクリックされたときの処理
  const handleConversationClick = (conversation) => {
    setSelectedConversation(conversation);
  };

  // 検索処理
  const handleSearch = (query, targetView = null) => {
    setSearchQuery(query);
    
    // 検索対象のビューが指定されていれば、そのビューに切り替える
    if (targetView) {
      setCurrentView(targetView);
    }
  };

  // フィルター適用処理
  const handleFilterChange = (newFilters) => {
    setFilters({ ...filters, ...newFilters });
  };

  // ローディング中の表示
  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // エラー発生時の表示
  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      {/* ヘッダー */}
      <Header onSearch={handleSearch} onLanguageChange={onLanguageChange} />
      
      {/* メインコンテンツエリア */}
      <Box sx={{ display: 'flex', flexGrow: 1, overflow: 'hidden' }}>
        {/* ナビゲーション */}
        <Navigation 
          currentView={currentView} 
          onNavItemClick={handleNavItemClick}
        />
        
        {/* メインコンテンツ */}
        <MainContent 
          currentView={currentView}
          conversations={conversations}
          themes={themes}
          tags={tags}
          favorites={favorites}
          selectedConversation={selectedConversation}
          onConversationClick={handleConversationClick}
          searchQuery={searchQuery}
          filters={filters}
          onFilterChange={handleFilterChange}
          onToggleFavorite={toggleFavorite}
          onSearch={handleSearch}
          onNavItemClick={handleNavItemClick}
        />
      </Box>
    </Box>
  );
}

export default AppContent;